import React from 'react';
import {
  Dashboard as DashboardIcon,
  Description as DocumentsIcon,
  Assignment as TasksIcon,
  Repeat as TemplatesIcon,
  VerifiedUser as AuditsIcon,
  Warning as CAPAIcon,
  ReportProblem as NonConformityIcon,
  Feedback as ComplaintsIcon,
  Bookmark as ClausesIcon,
  Assessment as RiskIcon,
  ChangeCircle as ChangeIcon,
  WarningAmber as QualityAlertIcon,
  HealthAndSafety as SafetyIcon,
  Report as HazardIcon,
  VisibilityOff as AnonymousIcon,
  LocalShipping as SuppliersIcon,
  EventNote as ManagementReviewIcon,
  Schema as ProcessIcon,
  Public as EnvironmentIcon,
  MenuBook as TrainingMgmtIcon,
  School as TrainingIcon,
  Flag as ObjectivesIcon,
  PrecisionManufacturing as EquipmentIcon,
  People as UsersIcon,
  Lock as PermissionsIcon,
  Business as DepartmentsIcon,
  Group as TeamsIcon,
  Security as RolesIcon,
  AccountTree as OrgChartIcon,
  History as ActivityLogsIcon,
  Settings as SettingsIcon,
  Dns as AssetsIcon,
  Shield as ThreatIcon,
  RuleFolder as ProjectIcon,
  Work as WorkIcon,
  GroupWork as GroupWorkIcon,
  Description as DescriptionIcon,
  LibraryBooks as LibraryBooksIcon,
  Extension as ExtensionIcon,
  Analytics as AnalyticsIcon,
  SettingsApplications as SettingsApplicationsIcon,
  Badge as OnboardingIcon,
  FactCheck as ComplianceIcon,
  ListAlt as FrameworksIcon,
  ConfirmationNumber as SupportTicketIcon,
  ChecklistRtl as ChecklistIcon
} from '@mui/icons-material';

export const NAV_ITEMS = {
  dashboard: { key: 'dashboard', text: 'Dashboard', path: '/app/dashboard', icon: <DashboardIcon />, permissions: ['dashboard.view'] },
  documents: {
    key: 'documents',
    text: 'Documents',
    path: '/app/documents',
    icon: <DocumentsIcon />,
    permissions: ['documents.view', 'documents.view_all', 'documents.view_team', 'documents.view_own']
  },
  tasks: {
    key: 'tasks',
    text: 'Process Improvement',
    path: '/app/process-improvement',
    icon: <TasksIcon />,
    permissions: ['tasks.view', 'tasks.view_all', 'tasks.view_team', 'tasks.view_assigned']
  },
  taskTemplates: {
    key: 'taskTemplates',
    text: 'Task Templates',
    path: '/app/task-templates',
    icon: <TemplatesIcon />,
    permissions: ['tasks.create', 'tasks.assign']
  },
  audits: {
    key: 'audits',
    text: 'Audits',
    path: '/app/audits',
    icon: <AuditsIcon />,
    permissions: ['audits.view', 'audits.view_all', 'audits.view_assigned']
  },
  capa: {
    key: 'capa',
    text: 'CAPA',
    path: '/app/capa',
    icon: <CAPAIcon />,
    permissions: ['capa.view', 'capa.view_all', 'capa.view_assigned']
  },
  nonconformities: {
    key: 'nonconformities',
    text: 'Nonconformities',
    path: '/app/nonconformities',
    icon: <NonConformityIcon />,
    permissions: ['nc.view', 'nc.manage']
  },
  complaints: {
    key: 'complaints',
    text: 'Complaints',
    path: '/app/complaints',
    icon: <ComplaintsIcon />,
    permissions: ['complaint.view', 'complaint.manage']
  },
  isoClauses: {
    key: 'isoClauses',
    text: 'ISO Clauses',
    path: '/app/iso-clauses',
    icon: <ClausesIcon />,
    permissions: ['clauses.view']
  },
  risks: {
    key: 'risks',
    text: 'Risk Register',
    path: '/app/risks',
    icon: <RiskIcon />,
    permissions: ['risk.view']
  },
  environmentalAspects: {
    key: 'environmentalAspects',
    text: 'Environmental Aspects & Impacts',
    path: '/app/environmental-aspects',
    icon: <EnvironmentIcon />,
    permissions: ['environment.view', 'environment.manage'],
    standards: ['iso14001']
  },
  changeManagement: {
    key: 'changeManagement',
    text: 'Change Management',
    path: '/app/change-management',
    icon: <ChangeIcon />,
    permissions: ['change.view']
  },
  qualityAlerts: {
    key: 'qualityAlerts',
    text: 'Quality Alerts',
    path: '/app/quality-alerts',
    icon: <QualityAlertIcon />,
    permissions: ['alert.view', 'alert.manage', 'alert.acknowledge']
  },
  safetyIncidents: {
    key: 'safetyIncidents',
    text: 'Safety Incidents',
    path: '/app/safety-incidents',
    icon: <SafetyIcon />,
    permissions: ['safety.view', 'safety.manage'],
    standards: ['iso45001']
  },
  hazardRegister: {
    key: 'hazardRegister',
    text: 'Hazard Register',
    path: '/app/hazards',
    icon: <HazardIcon />,
    permissions: ['hazard.view', 'hazard.manage'],
    standards: ['iso45001']
  },
  assetRegister: {
    key: 'assetRegister',
    text: 'Asset Register',
    path: '/app/assets',
    icon: <AssetsIcon />,
    permissions: ['isms.assets.view', 'isms.assets.manage']
  },
  threatIntelligence: {
    key: 'threatIntelligence',
    text: 'Threat Intelligence',
    path: '/app/threat-intelligence',
    icon: <ThreatIcon />,
    permissions: ['risk.view', 'risk.manage'],
    standards: ['iso27001']
  },
  projects: {
    key: 'projects',
    text: 'Projects',
    path: '/app/projects',
    icon: <ProjectIcon />,
    // permissions: ['project.view', 'project.manage'] // permissions not fully enforced yet in backend strictly, but ideally 
    standards: ['iso27001']
  },
  anonymousReports: {
    key: 'anonymousReports',
    text: 'Anonymous Reports',
    path: '/app/anonymous-reports',
    icon: <AnonymousIcon />,
    permissions: ['anon.view', 'anon.manage']
  },
  suppliers: {
    key: 'suppliers',
    text: 'Suppliers',
    path: '/app/suppliers',
    icon: <SuppliersIcon />,
    permissions: ['supplier.view', 'supplier.manage'],
    comingSoon: true
  },
  managementReviews: {
    key: 'managementReviews',
    text: 'Management Reviews',
    path: '/app/management-reviews',
    icon: <ManagementReviewIcon />,
    permissions: ['review.view', 'review.manage']
  },
  trainingManagement: {
    key: 'trainingManagement',
    text: 'Training Management',
    path: '/app/training-management',
    icon: <TrainingMgmtIcon />,
    permissions: ['training.manage']
  },
  training: {
    key: 'training',
    text: 'My Training',
    path: '/app/training',
    icon: <TrainingIcon />,
    permissions: ['training.view'],
    hideForRoles: ['org_admin']
  },
  onboarding: {
    key: 'onboarding',
    text: 'My Onboarding',
    path: '/app/onboarding',
    icon: <OnboardingIcon />,
    permissions: ['onboarding.view']
  },
  objectives: {
    key: 'objectives',
    text: 'Objectives & KPIs',
    path: '/app/objectives',
    icon: <ObjectivesIcon />,
    permissions: ['kpi.view', 'kpi.manage']
  },
  equipment: {
    key: 'equipment',
    text: 'Equipment',
    path: '/app/equipment',
    icon: <EquipmentIcon />,
    permissions: ['equipment.view', 'equipment.manage'],
    comingSoon: true
  },
  users: {
    key: 'users',
    text: 'Employees',
    path: '/app/users',
    icon: <UsersIcon />,
    permissions: ['users.view'],
    subItems: ['employeeChecklist']
  },
  employeeChecklist: {
    key: 'employeeChecklist',
    text: 'Checklist',
    path: '/app/employee-checklist',
    icon: <ChecklistIcon />,
    permissions: ['users.checklist']
  },
  permissions: {
    key: 'permissions',
    text: 'Permissions',
    path: '/app/permissions',
    icon: <PermissionsIcon />,
    permissions: ['users.manage_roles']
  },
  departments: {
    key: 'departments',
    text: 'Process',
    path: '/app/org-processes',
    icon: <DepartmentsIcon />,
    permissions: ['process.view', 'process.manage']
  },
  teams: {
    key: 'teams',
    text: 'Departments',
    path: '/app/departments',
    icon: <TeamsIcon />,
    permissions: ['org.view_structure', 'org.manage_teams']
  },
  orgChart: {
    key: 'orgChart',
    text: 'Org Chart',
    path: '/app/organizational-chart',
    icon: <OrgChartIcon />,
    permissions: ['org.view_structure']
  },
  activityLogs: {
    key: 'activityLogs',
    text: 'Activity Logs',
    path: '/app/activity-logs',
    icon: <ActivityLogsIcon />,
    permissions: ['system.view_activity_logs']
  },
  settings: {
    key: 'settings',
    text: 'Settings',
    path: '/app/settings',
    icon: <SettingsIcon />,
    permissions: ['system.manage_settings']
  },
  jobModule: {
    key: 'jobModule',
    text: 'Job',
    // path attribute removed to prevent navigation on parent click
    icon: <WorkIcon />,
    permissions: ['jobs.view', 'jobs.manage', 'jobs.positions.view', 'jobs.descriptions.view'],
    subItems: ['jobPositions', 'jobLibraries', 'jobAnalytics', 'jobSettings']
  },
  jobPositions: {
    key: 'jobPositions',
    text: 'Job Positions',
    path: '/app/jobs/positions',
    icon: <GroupWorkIcon />,
    permissions: ['jobs.positions.view', 'jobs.positions.manage']
  },
  jobDescriptions: {
    key: 'jobDescriptions',
    text: 'Job Descriptions',
    path: '/app/jobs/descriptions',
    icon: <DescriptionIcon />,
    permissions: ['jobs.descriptions.view', 'jobs.descriptions.manage']
  },
  jobLibraries: {
    key: 'jobLibraries',
    text: 'Competencies',
    path: '/app/jobs/libraries',
    icon: <LibraryBooksIcon />,
    permissions: ['jobs.libraries.view']
  },
  jobAnalytics: {
    key: 'jobAnalytics',
    text: 'Analytics',
    path: '/app/jobs/analytics',
    icon: <AnalyticsIcon />,
    permissions: ['jobs.analytics.view']
  },
  jobSettings: {
    key: 'jobSettings',
    text: 'Settings',
    path: '/app/jobs/settings',
    icon: <SettingsApplicationsIcon />,
    permissions: ['jobs.manage']
  },
  compliance: {
    key: 'compliance',
    text: 'Compliance',
    icon: <ComplianceIcon />,
    // permissions: ['compliance.view'], // temporarily removed
    subItems: ['complianceFrameworks']
  },
  complianceFrameworks: {
    key: 'complianceFrameworks',
    text: 'Personnel Risk & Activity',
    path: '/app/compliance/frameworks',
    icon: <FrameworksIcon />,
    permissions: ['system.view_personnel_risk']
  },
  supportTicket: {
    key: 'supportTicket',
    text: 'Support Tickets',
    path: '/app/support-tickets',
    icon: <SupportTicketIcon />,
    permissions: ['ticket.view', 'ticket.manage']
  }
};

export const PORTAL_CONFIG = {
  org_admin: {
    label: 'Admin / CEO',
    homeRoute: '/app/dashboard',
    menuGroups: [
      { label: 'Overview', items: ['dashboard'] },
      {
        label: 'Operations',
        items: ['documents', 'tasks']
      },
      {
        label: 'Compliance & Quality',
        items: ['audits', 'capa', 'nonconformities', 'isoClauses', 'risks', 'environmentalAspects', 'safetyIncidents', 'hazardRegister', 'changeManagement', 'qualityAlerts', 'anonymousReports']
      },
      {
        label: 'Suppliers & Customer Care',
        items: ['suppliers', 'complaints']
      },
      {
        label: 'Performance & Reviews',
        items: ['objectives', 'equipment', 'managementReviews']
      },
      {
        label: 'People & Training',
        items: ['trainingManagement', 'training']
      },
      {
        label: 'Administration',
        items: ['users', 'permissions', 'departments', 'orgChart', 'jobModule']
      },
      {
        label: 'System',
        items: ['activityLogs', 'settings', 'complianceFrameworks', 'supportTicket']
      }
    ]
  },
  compliance_manager: {
    label: 'Compliance Manager',
    homeRoute: '/app/onboarding',
    menuGroups: [
      { label: 'Overview', items: ['onboarding', 'dashboard'] },
      {
        label: 'Compliance & Quality',
        items: [
          'documents',
          'audits',
          'capa',
          'nonconformities',
          'risks',
          'environmentalAspects',
          'safetyIncidents',
          'hazardRegister',
          'changeManagement',
          'qualityAlerts',
          'anonymousReports'
        ]
      },
      {
        label: 'Information Security',
        items: ['isoClauses', 'assetRegister']
      },
      {
        label: 'Performance & Reviews',
        items: ['objectives', 'equipment', 'managementReviews']
      },
      {
        label: 'People & Training',
        items: ['trainingManagement', 'training']
      },
      {
        label: 'Administration',
        items: ['users', 'permissions', 'departments', 'orgChart', 'jobModule']
      },
      {
        label: 'System',
        items: ['activityLogs', 'settings', 'complianceFrameworks', 'supportTicket']
      }
    ]
  },
  department_manager: {
    label: 'Department Manager',
    homeRoute: '/app/onboarding',
    menuGroups: [
      { label: 'My Department', items: ['onboarding', 'tasks', 'capa', 'nonconformities', 'documents', 'complaints', 'equipment', 'training', 'objectives', 'environmentalAspects'] },
      { label: 'Safety', items: ['safetyIncidents', 'hazardRegister'] },
      { label: 'Operations', items: ['departments'] },
      { label: 'Alerts', items: ['qualityAlerts'] }
    ]
  },
  auditor: {
    label: 'Auditor',
    homeRoute: '/app/onboarding',
    menuGroups: [
      { label: 'Overview', items: ['onboarding', 'dashboard'] },
      { label: 'Audits', items: ['audits', 'nonconformities', 'documents', 'capa', 'complaints'] },
      { label: 'Compliance & Risks', items: ['risks', 'isoClauses', 'managementReviews', 'qualityAlerts', 'anonymousReports', 'suppliers'] },
      { label: 'Operations', items: ['departments', 'environmentalAspects', 'safetyIncidents', 'hazardRegister', 'equipment', 'objectives'] },
      { label: 'People', items: ['trainingManagement', 'training'] },
      { label: 'Administration', items: ['users', 'departments', 'orgChart', 'jobModule'] },
      { label: 'System', items: ['activityLogs', 'settings'] }
    ]
  },
  staff: {
    label: 'Employee',
    homeRoute: '/app/dashboard',
    menuGroups: [
      { label: 'Overview', items: ['dashboard', 'onboarding'] },
      { label: 'My Work', items: ['tasks', 'training'] },
      { label: 'Compliance & Quality', items: ['documents', 'qualityAlerts', 'complaints'] },
    ]
  },
  employee_new: {
    label: 'New Associate',
    homeRoute: '/app/onboarding',
    menuGroups: [
      { label: 'Onboarding', items: ['onboarding'] },
      { label: 'Account', items: ['settings'] }
    ]
  },
  exec_viewer: {
    label: 'Executive Viewer',
    homeRoute: '/app/dashboard',
    menuGroups: [
      { label: 'Overview', items: ['dashboard', 'onboarding'] },
      { label: 'Reporting', items: ['activityLogs', 'settings'] }
    ]
  },
  custom: {
    label: 'Custom Role',
    homeRoute: '/app/dashboard',
    menuGroups: [
      { label: 'Overview', items: ['dashboard', 'onboarding'] },
      {
        label: 'Operations',
        items: ['documents', 'tasks']
      },
      {
        label: 'Compliance & Quality',
        items: ['audits', 'capa', 'nonconformities', 'isoClauses', 'risks', 'environmentalAspects', 'safetyIncidents', 'hazardRegister', 'changeManagement', 'qualityAlerts', 'anonymousReports']
      },
      {
        label: 'Suppliers & Customer Care',
        items: ['suppliers', 'complaints']
      },
      {
        label: 'Performance & Reviews',
        items: ['objectives', 'equipment', 'managementReviews']
      },
      {
        label: 'People & Training',
        items: ['trainingManagement', 'training']
      },
      {
        label: 'Administration',
        items: ['users', 'permissions', 'departments', 'orgChart', 'jobModule']
      },
      {
        label: 'System',
        items: ['activityLogs', 'settings', 'complianceFrameworks', 'supportTicket']
      }
    ]
  },
  default: {
    label: 'Standard Employee',
    homeRoute: '/app/dashboard',
    menuGroups: [
      { label: 'My Work', items: ['tasks', 'training'] },
      { label: 'Awareness', items: ['documents', 'qualityAlerts', 'complaints'] },
      { label: 'Tools', items: ['risks', 'isoClauses', 'jobModule', 'audits', 'capa', 'nonconformities'] },
      { label: 'Support', items: ['supportTicket'] }
    ]
  }
};

export const ROLE_HOME_FALLBACK = '/app/dashboard';

export function resolvePortalKey(user) {
  if (!user) return 'default';

  // Handle Employee approval/onboarding logic FIRST (even if they have a custom role)
  if (user.role === 'employee' || !user.role) {
    const isActive = user.is_active || user.status === 'active';
    if (!isActive) {
      return 'employee_new'; // Until approved, keep in new associate portal (onboarding)
    }
    if (user.custom_role_id) return 'custom';
    return 'staff'; // Once approved, go to full staff portal
  }

  // If user has a custom role and NOT an employee, give them the FULL menu structure.
  if (user.custom_role_id) {
    return 'custom';
  }

  switch (user.role) {
    case 'org_admin':
      return 'org_admin';
    case 'compliance_manager':
      return 'compliance_manager';
    case 'auditor':
      return 'auditor';
    case 'viewer':
    case 'exec_viewer':
      return 'exec_viewer';
    default:
      return 'default';
  }
}

